// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2PSvo","large":"styles_large__1p1PV"};